"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTableOrders = void 0;
const getTableOrders = (sorting) => (Object.entries(sorting)
    .filter(([, direction]) => !!direction)
    .map(([field = '', direction = '']) => ({
    field,
    direction: direction.toUpperCase(),
})));
exports.getTableOrders = getTableOrders;
//# sourceMappingURL=get-table-orders.js.map